var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',[_c('ulu-finance-revenue')],1)],1),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[_c('ulu-finance-kpi')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }